import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSolarPanel, faWind, faWater, faCircle, faBolt} from "@fortawesome/free-solid-svg-icons";
import { faFilePdf, faFileCsv, faFileExcel, faFileWord, faFile } from '@fortawesome/free-solid-svg-icons';

// Use a solar-panel icon (filled) for solar resources instead of the sun glyph
export const getResourceIcon = (resource, sizeClass = 'h-5 w-5') => {
  // Accept either a resource object or a plain string describing the use case
  const useCaseRaw = typeof resource === 'string' ? resource : (resource && (resource.use_case || resource.useCase || resource.resource || ''));
  const key = (useCaseRaw || '').toString().toLowerCase();

  // stronger contrast with dark: variants
  if (key.includes('wind')) return <FontAwesomeIcon icon={faWind} className={`text-sky-600 dark:text-sky-300 ${sizeClass}`}/>;
  if (key.includes('solar')) return <FontAwesomeIcon icon={faSolarPanel} className={`text-yellow-600 dark:text-yellow-300 ${sizeClass}`}/>;
  if (key.includes('hydro') || key.includes('water')) return <FontAwesomeIcon icon={faWater} className={`text-blue-600 dark:text-blue-300 ${sizeClass}`}/>;
  if (key.includes('mfrr')) return <FontAwesomeIcon icon={faBolt} className={`text-amber-600 dark:text-amber-300 ${sizeClass}`}/>;

  // Hybrid resources: show two small icons side-by-side with dark variants
  if (key.includes('hybrid')) {
    return (
      <div className="flex items-center gap-1">
        <FontAwesomeIcon icon={faWind} className={`text-sky-600 dark:text-sky-300 ${sizeClass}`} />
        <FontAwesomeIcon icon={faSolarPanel} className={`text-yellow-600 dark:text-yellow-300 ${sizeClass}`} />
      </div>
    );
  }

  // fallback: show a neutral circle icon (no square background) with dark-aware color
  return <FontAwesomeIcon icon={faCircle} className={`text-slate-500 dark:text-slate-300 ${sizeClass}`}/>;
}

// New helper: returns a file-type icon (no outside shell) using the file extension inferred from a filename or URL.
export const getFileIcon = (fileName, fileUrl) => {
  const source = (fileUrl && typeof fileUrl === 'string' ? fileUrl : fileName || '') || '';
  const cleaned = String(source).split('?')[0].split('#')[0];
  const parts = cleaned.split('.');
  const ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';

  let icon = faFile;
  let colorClass = 'text-gray-700 dark:text-gray-200';

  if (ext === 'csv') {
    colorClass = 'text-green-600 dark:text-green-400';
    icon = faFileCsv;
  } else if (ext === 'pdf') {
    colorClass = 'text-red-600 dark:text-red-400';
    icon = faFilePdf;
  } else if (ext === 'doc' || ext === 'docx') {
    colorClass = 'text-brand-600 dark:text-brand-400';
    icon = faFileWord;
  } else if (ext === 'xls' || ext === 'xlsx') {
    colorClass = 'text-green-600 dark:text-green-400';
    icon = faFileExcel;
  } else if (ext === 'json') {
    colorClass = 'text-yellow-600 dark:text-yellow-400';
    icon = faFile;
  } else if (ext === 'zip' || ext === 'rar' || ext === '7z') {
    colorClass = 'text-brand-600 dark:text-brand-400';
    icon = faFile;
  }

  // keep the same wrapper used in Files.js: flex-shrink and margin for spacing
  return (
    <div className="flex-shrink-0 mr-3" aria-hidden>
      <FontAwesomeIcon icon={icon} className={`${colorClass} w-6 h-6`} />
    </div>
  );
}
